import { createContext } from 'react';

import { useNewbuildingBrokerWidgetAPI } from './useNewbuildingBrokerWidgetAPI';

type TValue = {
  isBrokerAvailable: boolean;
  openWidget: ReturnType<typeof useNewbuildingBrokerWidgetAPI>['openWidget'];
};

const defaultValue = {
  isBrokerAvailable: false,
  openWidget: () => Promise.resolve(),
};

export const NewbuildingBrokerWidgetContext = createContext<TValue>(defaultValue);
